import { call, put } from "redux-saga/effects";
import { fetchGameWinners } from "../../../api";
import { profileActions } from "../../../actions/profile";

export function* fetchGameWinnersSaga({ payload: { gameId } }) {
  try {
    const { response } = yield call(fetchGameWinners, gameId);
    if (response) {
      yield put(profileActions.fetchGameWinnersSuccess(response));
    }
  } catch (error) {
    yield put(profileActions.fetchGameWinnersFailure(error));
  }
}